// SEQ-218: when a saved claim's summary page is rebuilt from its row, progress
// works this claim is recovered as the subtotal minus the other components. The
// subtotal holds only NEW hire: months re-claimed from earlier claims are
// shown in "Install & Hire this claim" but were left out of the subtotal, so
// only the new part is subtracted. A claim saved before re-claims existed has
// no install_hire_reclaimed, which reads as 0 (nothing changes for it).

const round2 = (n: number) => Math.round((n + Number.EPSILON) * 100) / 100;

export function contractValueFromSubtotal(input: {
  subtotal: number;
  variationsThisMonth: number;
  variationsOutstanding: number;
  installHireThisMonth: number;
  installHireReclaimed?: number | null;
}): number {
  const reclaimed = Number(input.installHireReclaimed ?? 0) || 0;
  const newHire = input.installHireThisMonth - reclaimed;
  return round2(
    Math.max(
      0,
      input.subtotal - input.variationsThisMonth - input.variationsOutstanding - newHire,
    ),
  );
}
